import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { requestFailed } from '../../app/actions/RequestFailedAction';
import { Messages } from '../../codegen/Localize';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { FlowListItemInfo } from '../../ts/models/FlowInfo';
import { Set } from '../../ts/models/Set';
import { showRunFlowDialog } from '../actions/RunFlowAction';
import { RunFlowReduxAction } from '../actions/RunFlowReduxAction';
import { getFlowListItemInfos } from '../FlowsSagaHelpers';

export function openRunFlowsDialog(flowListItemInfos: FlowListItemInfo[]): Promise<IResult> {
  const flowSet = Set.fromIdItemArray(flowListItemInfos);
  return showRunFlowDialog(flowSet);
}

export function* handleRunFlow(action: RunFlowReduxAction): SagaIterator {
  try {
    if (action.selectedContent && action.selectedContent[0].contentType === 'flow') {
      const flowListItemInfos = yield call(getFlowListItemInfos, action.selectedContent);
      yield call(openRunFlowsDialog, flowListItemInfos);
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}
